(function() {
	'use strict';

	angular
		.module('app')
		.controller('modalContactFormController', modalContactFormController);

	modalContactFormController.$inject = ['$element', 'gtmEventsService'];

	function modalContactFormController($element, gtmEventsService) {
		/* jshint validthis:true */
		var vm = this;
		vm.name = null;
		vm.form = null;
		vm.preValues = null;
		vm.formOpen = false;
		vm.init = init;
		vm.preFillForm = preFillForm;
		vm.openForm = openForm;
		vm.toggleForm = toggleForm;
		vm.closeForm = closeForm;

		var typingStarted = false;

		function init(formName) {
			vm.name = formName;
			vm.form = $('#' + vm.name);

			if (vm.form !== 'undefined') {
				var buttons = $(document).find('[data-target="#' + formName + '"]');
				$(buttons).each(function () {
					var preValues = $(this).attr('data-prevalues');
					if (preValues !== '' & preValues != null) {
						$(this)[0].addEventListener('click', function () {
							vm.toggleForm(preValues);
						});
					}

					$(this)[0].addEventListener('click', handleFormOpening);
				});

				$element.find('form input').on("input", handleChange);
				$element.find('form input').on("change", handleChange);
			}
		}
		function toggleForm(preValues) {
			event.preventDefault();

		    if (vm.formOpen) {
		        vm.closeForm();
	        } else {
		        vm.openForm(preValues);
	        }
	        
	    }
	    function openForm(preValues) {
			vm.preValues = preValues;
	        vm.formOpen = true;

	        if (preValues !== 'undefined') {
		        vm.preFillForm(preValues);
			}
	    }
	    function closeForm() {
		    if (vm.preValues !== null & vm.preValues !== '') {
				vm.formOpen = false;
				var valArrays = vm.preValues.split(',');
				valArrays.forEach(function (element) {
					var elementArr = element.split('=');
					var id = elementArr[0];
					var formElement = $('div').find('[data-f-element-name="__field_' + id + '"]');
					var type = formElement.attr('data-f-type');

					if (type === 'textbox') {
						var input = $(formElement[0]).find('input');
						$(input).val('');
						var textarea = $(formElement[0]).find('textarea');
						$(textarea).val('');
					}
					else if (type === 'selection') {
						var select = $(formElement[0]).find('select');
						$(select).val('').change();
					}
					else if (type === 'choice') {
						$(formElement[0]).find('input[type=checkbox]').each(function () {
							if (($(this).val() === elementArr[1])) {
								$(this).attr('checked', false);
							}
						});
					}
				});
			}
			vm.preValues = null;
	    }
	    function preFillForm(preValues) {
		    var form = $('#' + vm.name);
		    if (form !== null) {
			    var valArrays = preValues.split(',');
		        valArrays.forEach(function (element) {

		            var elementArr = element.split('=');
	                var id = elementArr[0];
	                var value = elementArr[1];
	                var formElement = $('div').find('[data-f-element-name="__field_' + id + '"]');
	                var type = formElement.attr('data-f-type');

					if (type === 'textbox') {
						var input = $(formElement[0]).find('input');
						if (input.length > 0) {
							$(input).val(value);
						} else {
							var textarea = $(formElement[0]).find('textarea');
							$(textarea).val(value);
						}
					}
					else if (type === 'selection') {
						var select = $(formElement[0]).find('select');
						$(select).val(value).change();
					}
					else if (type === 'choice') {
						$(formElement[0]).find('input[type=checkbox]').each(function () {
							if (($(this).val() === value)) {
								$(this).attr('checked', true);
							}
						});
					}
	            });
	        }
		}

		var handleChange = function () {
			if (!typingStarted) {
				var contactType = null;
				var selectedContactType = $("input.FormChoice__Input--Radio:checked").val();

				if (selectedContactType !== undefined) {
					contactType = selectedContactType;
                }

				gtmEventsService.startFormTyping(vm.name, contactType);
				typingStarted = true;
            }
		};

		var handleFormOpening = function () {
			// reset the flag. "Typing" event will be re-sent if the form is re-opened again.
			if (typingStarted) {
				typingStarted = false;
			}

			gtmEventsService.startForm(vm.name);
		};
	}
})();
